import Controller from "csi/action/Controller";
import def from "csi/def";
import { Type } from "csi/def/Type";
import reflection from "csi/reflection";
import declare from "dojo/_base/declare";

/**
 * Example logic to find properties of Tabs views
 */
function findTabViewAttributes(typeDef: Type, xn: HTMLElement): void {
	const viewType = xn.getAttribute("xsi:type");
	const type = typeDef.getType();

	if (viewType === "Tabs") {
		const id = xn.getAttribute("Id");
		const viewDef = typeDef.getViewDef(id);

		if (viewDef.defToolbar) {
			console.log("toolbar: ", type, id);
		}

		if (viewDef.m_depPaths) {
			console.log("paths: ", type, id);
		}

		viewDef.m_rules?.forEach((rule) => {
			if (rule.m_path) {
				console.log("rule: ", type, id);
			}
		});
	}
}

export = declare(Controller, {
	postProcessSuccess() {
		reflection.getClasses().forEach((rc) => {
			const type = rc.getType();
			const typeDef = def.typeDefinition(type);

			typeDef.traverseViewTags((xn) => {
				// TODO: Add logic here to find what you are looking for
				const id = xn.getAttribute("Id");
				const viewType = xn.getAttribute("xsi:type");
				console.log("View: ", type, id, viewType);
			});
		});
	},
});
